import React, { useEffect, useState } from "react";
import { Button, message, Form, Input } from "antd";
import { CheckCircleOutlined, KeyOutlined } from "@ant-design/icons";
import axios from "axios";
import useStore from "../../store/useStore";
import imgSMS from "../../assets/img/sms-icon.svg";

const VerifyEmail = () => {
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const email = useStore((state) => state?.user?.email ?? "-");
  const codeVerified = useStore((state) => state?.user?.codeVerified ?? false);
  const resendVerification = async () => {
    setResending(true);
    try {
      const { data } = await axios.post(
        `/api/v1/me/request-email-verification`,
      );
      if (data.statusCode === 200) {
        message.success({
          content: data.result.message ?? "Амжилттай",
          duration: 5,
          className: "message-success",
          icon: (
            <CheckCircleOutlined style={{ color: "#2FA1D9", fontSize: 22 }} />
          ),
        });
      }
    } catch (e) {
      console.error("Request Email Verification: ", e);
    } finally {
      setResending(false);
    }
  };
  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { data } = await axios.post("/auth/verifyOTP", {
        email: email,
        code: values?.code,
      });

      setLoading(false);
      if (data?.statusCode === 200) {
        message.success(data?.result?.message || "Амжилттай");
        localStorage.clear();
        window.location.href = "/";
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const emailVerifiedCheck = async () => {
    const body = { email };
    try {
      const { data } = await axios.post("/auth/verifyEmailCheck", body);

      if (data?.statusCode === 200 && data?.result?.emailVerified) {
        localStorage.clear();
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Email verified check: ", error);
    }
  };

  useEffect(() => {
    emailVerifiedCheck();
    // Хуудас нээгдэхэд нэг л удаа шалгана.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={imgSMS} alt="Имэйл баталгаажуулалт" />
      <p style={{ fontSize: 21, fontWeight: 700, marginTop: 24 }}>
        Та имэйл хаягаа баталгаажуулна уу.
      </p>

      {!codeVerified ? (
        <React.Fragment>
          <p
            style={{
              fontWeight: 500,
              width: 332,
              textAlign: "center",
              marginTop: 8,
              marginBottom: 32,
            }}
          >
            Таны <strong style={{ color: "#05a0c0" }}>{email}</strong> имэйл
            хаягт очсон баталгаажуулах кодыг оруулна уу!
          </p>
          <Form className="login-form" onFinish={onFinish}>
            <Form.Item
              name="code"
              rules={[
                {
                  required: true,
                  message: "Кодоо оруулна уу!",
                },
              ]}
            >
              <Input
                className="all_buttons"
                size="large"
                prefix={<KeyOutlined className="site-form-item-icon" />}
                placeholder="Кодоо энд бичнэ үү"
                allowClear
              />
            </Form.Item>

            <div
              style={{
                textAlign: "center",
                marginTop: 20,
                marginBottom: "3rem",
              }}
            />
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className="login-form-button all_buttons"
                loading={loading}
              >
                Баталгаажуулах
              </Button>
            </Form.Item>
          </Form>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <p
            style={{
              fontWeight: 500,
              width: 332,
              textAlign: "center",
              marginTop: 8,
              marginBottom: 32,
            }}
          >
            Таны <strong style={{ color: "#05a0c0" }}>{email}</strong> имэйл
            хаягт баталгаажуулах холбоос очоогүй бол
          </p>
          <Button
            className="all_buttons"
            type={"primary"}
            onClick={resendVerification}
            loading={resending}
          >
            ЭНД ДАРНА УУ!
          </Button>
        </React.Fragment>
      )}
      <div
        style={{
          marginTop: 40,
          padding: "16px 20px",
          background: "#f5f9ff",
          borderRadius: 8,
          border: "1px solid #e1edff",
          maxWidth: 360,
          width: "100%",
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: 13,
            color: "#666",
            lineHeight: "1.5",
            textAlign: "center",
          }}
        >
          <strong>Зөвлөмж:</strong> Имэйл ирээгүй бол Spam хавтсаа шалгана уу
          !!!
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;
